<template>
  <job-preview-content-outline
    :title="title"
    data-test="interview"
    v-on="$listeners"
  >
    <job-preview-content
      :comment-highlights="commentHighlights"
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      :text-counts="textCounts"
      v-on="$listeners"
    >
      <template #body>
        <p>
          <span
            v-if="zip"
            :id="`${targetIdMap.selection.interview.zip}-${index}`"
            data-test="zip"
            v-html="`〒 ${zip}<br>`"
          />
          <span
            v-if="address"
            :id="`${targetIdMap.selection.interview.address}-${index}`"
            class="pega-pre-wrap"
            data-test="address"
            v-html="`${address}<br>`"
          />
          <span
            v-if="person"
            :id="`${targetIdMap.selection.interview.person}-${index}`"
            data-test="person"
            v-html="`担当者 ／ ${person}<br>`"
          />
          <span
            v-if="tel"
            :id="`${targetIdMap.selection.interview.tel}-${index}`"
            data-test="tel"
            v-text="`Tel ／ ${tel}`"
          />
        </p>
        <p
          v-if="map"
          class="btn-style-02 pt10 pb10 map-button"
          data-test="map"
        >
          <a
            :href="`${googleMapURL}${map}`"
            :style="`background: url(${userCommonImageUrlForPc}/icn_arrow_05.png) no-repeat 8px center;`"
            target="_blank"
            data-test="map-button"
          >
            <span>地図を見る</span>
          </a>
        </p>
      </template>
    </job-preview-content>
  </job-preview-content-outline>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContentOutline from '@/components/atoms/JobPreviewContentOutline'
import JobPreviewContent from '@/components/atoms/JobPreviewContent'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  components: {
    JobPreviewContentOutline,
    JobPreviewContent
  },
  mixins: [jobPreviewCommon],
  props: {
    index: {
      type: Number,
      required: true
    },
    zip: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    person: {
      type: String,
      default: ''
    },
    tel: {
      type: String,
      default: ''
    },
    map: {
      type: String,
      default: ''
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    title () {
      return this.index === 1 ? '面接会場' : `面接会場${this.index}`
    },
    textCounts () {
      return [
        this.getTextCount('住所', this.address, this.targetIdMap.selection.interview.address),
        this.getTextCount('担当者', this.person, this.targetIdMap.selection.interview.person),
        this.getTextCount('TEL', this.tel, this.targetIdMap.selection.interview.tel)
      ]
    }
  }
}
</script>
